import { render, staticRenderFns } from "./ImportsParams.vue?vue&type=template&id=1789fa36&scoped=true"
import script from "./ImportsParams.vue?vue&type=script&lang=js"
export * from "./ImportsParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1789fa36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1789fa36')) {
      api.createRecord('1789fa36', component.options)
    } else {
      api.reload('1789fa36', component.options)
    }
    module.hot.accept("./ImportsParams.vue?vue&type=template&id=1789fa36&scoped=true", function () {
      api.rerender('1789fa36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/parameters/ImportsParams.vue"
export default component.exports